import { create } from 'zustand'

type AuthUser = {
  displayName?: string | null
  email?: string | null
  photoURL?: string | null
} | null

type AuthState = {
  user: AuthUser
  setUser: (u: AuthUser) => void
}

export const useAuthStore = create<AuthState>((set) => ({
  user: null,
  setUser: (u) => set({ user: u }),
}))